import React from "react";
import { Form, Checkbox, message } from "antd";
import styled from "styled-components";

import colors from "constants/palette";
import Button from "components/buttons/Button";
import Input from "components/inputs/Input";
import NumberInput from "components/inputs/NumberInput";
import Select from "components/inputs/Select";
import Fetch from "components/Fetch";
// import Loading from "components/App/Loading";

export default function CustomerStep({ info, setCustomer, customer }) {
  const [form] = Form.useForm();
  const [newCustomer, setNewCustomer] = React.useState(false);

  function AddCustomer(data) {
    Fetch.post("/customer", { ...data, data: JSON.stringify({}) }, (res) => {
      console.log("new customer response", res);
      if (res?.id) {
        message.success("مشتری با موفقیت اضافه شد");
        setCustomer(data.name);
        setNewCustomer(false);
        return true;
      } else {
        if (res?.errors.name) {
          message.error(res?.errors.name[0]);
        } else {
          message.error("خطایی رخ داده است");
        }
        return false;
      }
    });
  }

  return (
    <Form
      form={form}
      layout="vertical"
      style={{ direction: "rtl" }}
      scrollToFirstError
      onFinish={AddCustomer}
    >
      <Col>
        <Label>نام مشتری :</Label>
        <Form.Item
          name="name"
          rules={[{ required: true, message: "لطفا نام مشتری را وارد کنید!" }]}
        >
          {newCustomer ? (
            <Input size="large" placeholder="" />
          ) : (
            <Select
              no_default={customer ? "false" : "true"}
              borderradius="0"
              list={info.customers.map((e) => ({ title: e.name }))}
              showSearch
              placeholder="جستجو"
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              filterSort={(optionA, optionB) =>
                optionA.children
                  .toLowerCase()
                  .localeCompare(optionB.children.toLowerCase())
              }
              onChange={(a, e) => setCustomer(a)}
              value={customer}
            />
          )}
        </Form.Item>
        <p>
          مشتری جدید :{" "}
          <Checkbox
            onChange={({ target }) => setNewCustomer(target.checked)}
            checked={newCustomer}
          />
        </p>
        {newCustomer && (
          <>
            <Label>نام فروشگاه :</Label>
            <Form.Item
              name="shop"
              rules={[
                {
                  required: true,
                  message: "لطفا نام فروشگاه را وارد کنید!",
                },
              ]}
            >
              <Input size="large" placeholder="" />
            </Form.Item>
            <Label>شهر :</Label>
            <Form.Item
              name="city"
              rules={[
                {
                  required: true,
                  message: "لطفا شهر را وارد کنید!",
                },
              ]}
            >
              <Select
                list={cities}
                showSearch
                placeholder="جستجو"
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
                filterSort={(optionA, optionB) =>
                  optionA.children
                    .toLowerCase()
                    .localeCompare(optionB.children.toLowerCase())
                }
                borderradius="2px"
                style={{ minWidth: "100%" }}
              />
            </Form.Item>
            <Label>آدرس فروشگاه :</Label>
            <Form.Item
              name="address"
              rules={[
                {
                  required: true,
                  message: "لطفا آدرس فروشگاه را وارد کنید!",
                },
              ]}
            >
              <Input size="large" placeholder="" />
            </Form.Item>
            <Label>تلفن :</Label>
            <Form.Item
              name="phone"
              rules={[
                {
                  required: true,
                  message: "لطفا تلفن را وارد کنید!",
                },
              ]}
            >
              <NumberInput style={{ width: "100%" }} />
            </Form.Item>
            <Button onClick={form.submit}>اضافه کردن مشتری</Button>
          </>
        )}
      </Col>
    </Form>
  );
}
const Col = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 200px;
`;
const Label = styled.label`
  margin-bottom: 10px;
  display: block;
  color: ${colors.dark};
`;
const cities = [
  "آمل",
  "بابل",
  "بابلسر",
  "بلده",
  "بهشهر",
  "پل سفيد",
  "تنكابن",
  "جويبار",
  "چالوس",
  "خرم آباد",
  "رامسر",
  "رستم کلا",
  "ساري",
  "سلمانشهر",
  "سواد كوه",
  "فريدونكنار",
  "قائم شهر",
  "گلوگاه",
  "محمودآباد",
  "مرزن آباد",
  "نكا",
  "نور",
  "نوشهر",
  "امیرکلا",
  "کتالم وسادات شهر",
  "زیرآب",
  "عباس‌آباد",
  "خلیل شهر",
  "شیرود",
  "چمستان",
  "کلاردشت",
  "هچیرود",
  "ارطه",
  "سورک",
  "شیرگاه",
  "بهنمیر",
  "کیاکلا",
  "هادی‌شهر",
  "رویان",
  "ایزدشهر",
  "گتاب",
  "سرخرود",
  "نشتارود",
  "کلارآباد",
  "آستانه نو",
  "امامزاده عبدالله",
  "خوش‌رودپی",
  "اجبارکلا",
  "زرگر",
  "کیاسر",
  "پول",
  "کجور",
  "کوهی‌خیل",
  "فرح آباد",
  "طبقده",
  "دابودشت",
  "آکند",
  "آلاشت",
  "رینه",
  "پایین هولار",
  "مرزیکلا",
  "فریم",
  "گزنک",
];
